import { render, staticRenderFns } from "./auto-complete-v2.vue?vue&type=template&id=5838f2d2&scoped=true"
import script from "./auto-complete-v2.vue?vue&type=script&lang=js"
export * from "./auto-complete-v2.vue?vue&type=script&lang=js"
import style0 from "./auto-complete-v2.vue?vue&type=style&index=0&id=5838f2d2&prod&scoped=true&lang=css"
import style1 from "./auto-complete-v2.vue?vue&type=style&index=1&id=5838f2d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838f2d2",
  null
  
)

export default component.exports